// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon--uFQys"};